import { render, staticRenderFns } from "./WfDevComplaintModal.vue?vue&type=template&id=04d1a5e4&"
import script from "./WfDevComplaintModal.vue?vue&type=script&lang=js&"
export * from "./WfDevComplaintModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports